'use client';

import type { Placement, ProductType } from '@hc-frontend/core-types';
import { useEffect } from 'react';

export type GTMVariablesLoaderProps = {
  placement: Placement;
  productType: ProductType;
  source?: string;
};

export function GTMVariablesLoaderClient({
  placement,
  productType,
  source,
}: GTMVariablesLoaderProps) {
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(
      { placement },
      { product_type: productType },
      { src: source },
      { event: 'context_loaded' },
    );
  }, [placement, productType, source]);

  return null;
}
